exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, ".justify-center {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-pack: center;\n  justify-content: center; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/screens/XmlExports/AddEdit/AddEditXmlExports.scss
// module id = 1759
// module chunks = 0